import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '@apollo/client/react/hoc';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ViewPayoutQR.css';

// Query
import viewPayoutQRAdmin from './viewPayoutQRAdmin.graphql';

// Component

import Loader from '../../../components/Loader/Loader';
import NotFound from '../../notFound/NotFound';
import cx from 'classnames';
import ViewPaymentQR from '../../../components/siteadmin/ViewPaymentQR/ViewPaymentQR';
import { withQuery } from '../../../hoc/withGraphql';


class ViewPayoutQRRoute extends React.Component {
	static propTypes = {
		type: PropTypes.shape,
		data: PropTypes.shape({
			loading: PropTypes.bool,
			getAllReservationAdmin: PropTypes.array,
		})
	};

	render() {
		const { data: { getAllPaymentQR, loading, refetch }, type } = this.props;

		if (loading) {
			return <Loader type={"text"} />;
		}
		if (getAllPaymentQR === null) {
			return <div className={cx(s.pagecontentWrapper)}><NotFound /></div>
		}

		return <ViewPaymentQR data={getAllPaymentQR}
			refetch={refetch}
			type={type}
		/>;
	}

}

export default compose(
	withStyles(s),
	withQuery(viewPayoutQRAdmin,
		{
			//name: 'getAllPaymentQR',
			options: (props) => ({
				variables: {
					id: props.id,
					searchKey: '',
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		}),
)(ViewPayoutQRRoute);
